import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ErrorPage } from "@/components/error-page/ErrorPage";
import { ECashierFlows, EIcon } from "@/utils/enums";

export const DepositNotAvailable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <ErrorPage
      icon={EIcon.EmptyStateError}
      showButton={true}
      buttonLabel={t("global.nav_buttons.back_to_home")}
      buttonAction={() => navigate(`/${ECashierFlows.Deposit}`)}
      title={t("deposit.methods.deposit_not_available")}
      message={
        <>
          {t("deposit.methods.deposit_not_available_text")}
          <br />
          {t("deposit.methods.for_more_info_contact")}{" "}
          <a href="mailto:support@pepperstone.com">support@pepperstone.com</a>
        </>
      }
    />
  );
};
